<template>
    <label
        for="att-view-hover-toggle"
        class="flex items-center select-none cursor-pointer"
        title="Forhåndsvis vedlegg ved å flytte musepeker over, eller med museklikk?"
    >
        <i class="i-ph-mouse-left-click-fill text-gray-400 hover:text-primary" :class="{'text-primary': !isHoverToOpenDocumentPreviewModal}"/> /
        <i class="i-ph-cursor-fill text-gray-400 hover:text-primary" :class="{'text-primary': isHoverToOpenDocumentPreviewModal}"/>
        <input
            id="att-view-hover-toggle"
            v-model="isHoverToOpenDocumentPreviewModal"
            type="checkbox"
            class="checkbox-sm hidden"
        >
    </label>
</template>

<script setup lang="ts">
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'

const {isHoverToOpenDocumentPreviewModal} = useDocumentPreviewModalService()
</script>

<style scoped>

</style>